<!-- PaymentIcon.vue -->
<template>
  <svg :class="iconClass" width="24" height="24" viewBox="0 0 24 24" fill="none">                
    <path d="M3.4 10.5519V17.1519H8.2V12.3519C8.2 12.0337 8.32643 11.7284 8.55147 11.5034C8.77652 11.2784 9.08174 11.1519 9.4 11.1519H10.6C10.9183 11.1519 11.2235 11.2784 11.4485 11.5034C11.6736 11.7284 11.8 12.0337 11.8 12.3519V17.1519H16.6V10.5519" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M1 9.35192L9.152 1.19992C9.26287 1.08769 9.39492 0.998584 9.54048 0.937767C9.68605 0.876951 9.84224 0.845634 10 0.845634C10.1578 0.845634 10.314 0.876951 10.4595 0.937767C10.6051 0.998584 10.7371 1.08769 10.848 1.19992L19 9.35192" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    <path d="M13.6 3.95191V1.61591H16.6V6.95191" stroke="#333333" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  </svg>
</template>

<script setup>
defineProps({
  iconClass: {
    type: String,
    default: '',
  }
});
</script>
